import { createApi } from '@reduxjs/toolkit/query/react';
import { ApiBaseName, ApiReducerPath } from '@Enum/index';
import { customBaseQuery } from '@Utils/api/customBaseQuery';

export const permissionsApi = createApi({
  reducerPath: ApiReducerPath.API_PERMISSIONS,
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    getESSUserPermissions: builder.query<string[], void>({
      query: () => ({
        url: `${ApiBaseName.ESS}/sec/permissions`,
        method: 'get',
      }),
    }),
    getMRUserPermissions: builder.query<string[], void>({
      query: () => ({
        url: `${ApiBaseName.REQUISITION}/sec/permissions`,
        method: 'get',
      }),
    }),
  }),
});

export const { useGetESSUserPermissionsQuery, useGetMRUserPermissionsQuery } =
  permissionsApi;
